import { Chip } from "@mui/material";
import { ClasseAtivo } from "../../../models/enum";
import { tintDeCor } from "./tintDeCor";

type Props = {
  classeAtivo: ClasseAtivo;
};

/**
 * Classe de ativo é **categoria**, não status — e o contador usa a cor para
 * distinguir FII de Opção batendo o olho numa tabela longa. Por isso cada classe
 * mantém a SUA cor (nada de colapsar 14 em 4), renderizada como tint do sistema
 * via `tintDeCor`. Ver o comentário longo em `tintDeCor.ts`.
 *
 * A mesma cor alimenta o donut de `analises/distribuicao`.
 */
export type PropClasseAtivo = {
  /** Cor da categoria. Usada no chip (via `tintDeCor`) e como série no donut. */
  cor: string;
  label: string;
};

const CLASSES: Record<ClasseAtivo, PropClasseAtivo> = {
  [ClasseAtivo.ACAO]: { label: "Ação", cor: "#3075BA" },
  [ClasseAtivo.BDR]: { label: "BDR", cor: "#8F29D6" },
  [ClasseAtivo.ETF]: { label: "ETF", cor: "#7138EC" },

  [ClasseAtivo.FII]: { label: "FII", cor: "#EF6A32" },
  [ClasseAtivo.FIAGRO]: {
    label: "FIAGRO",
    cor: "#F8A328",
  },
  [ClasseAtivo.FI_INFRA]: {
    label: "FI INFRA",
    cor: "#D97423",
  },
  [ClasseAtivo.FIP_IE]: {
    label: "FIP IE",
    cor: "#D93F23",
  },
  [ClasseAtivo.FIP_MULTI]: {
    label: "FIP MULTI",
    cor: "#F82928",
  },

  [ClasseAtivo.OPCAO]: { label: "Opção", cor: "#4030C9" },
  [ClasseAtivo.DIREITO]: {
    label: "Direito",
    cor: "#2AC7B6",
  },
  [ClasseAtivo.DOLAR]: { label: "Dólar", cor: "#85BB65" },
  [ClasseAtivo.INDICES]: {
    label: "Índices",
    cor: "#C7C561",
  },
  [ClasseAtivo.JUROS]: { label: "Juros", cor: "#C7C561" },

  [ClasseAtivo.ETF_RF]: {
    label: "ETF RF",
    cor: "#2F5BF7",
  },
  [ClasseAtivo.OUTROS]: {
    label: "Outros",
    cor: "#303030",
  },
};

export function ClasseChip({ classeAtivo }: Props) {
  const propClasse = propClasseAtivo(classeAtivo);
  return (
    <Chip
      size="small"
      label={propClasse.label}
      sx={(theme) => ({
        ...tintDeCor(propClasse.cor, theme),
      })}
    />
  );
}

export function propClasseAtivo(classe: ClasseAtivo): PropClasseAtivo {
  return CLASSES[classe] ?? CLASSES[ClasseAtivo.OUTROS];
}
